export function i18nAmount(
  amount: number,
  { singular, plural }: { singular: string; plural: string },
) {
  if (amount === 1) {
    return `${amount} ${singular}`;
  }
  return `${amount} ${plural}`;
}
